export const adminPaymentGatewaysConstants = {
  // Payment Gateways
  PAYMENT_GATEWAYS_FETCH_REQUEST: 'PAYMENT_GATEWAYS_FETCH_REQUEST',
  PAYMENT_GATEWAYS_FETCH_SUCCESS: 'PAYMENT_GATEWAYS_FETCH_SUCCESS',
  PAYMENT_GATEWAYS_FETCH_FAILURE: 'PAYMENT_GATEWAYS_FETCH_FAILURE',

  PAYMENT_GATEWAY_CREATE_REQUEST: 'PAYMENT_GATEWAY_CREATE_REQUEST',
  PAYMENT_GATEWAY_CREATE_SUCCESS: 'PAYMENT_GATEWAY_CREATE_SUCCESS',
  PAYMENT_GATEWAY_CREATE_FAILURE: 'PAYMENT_GATEWAY_CREATE_FAILURE',

  PAYMENT_GATEWAY_UPDATE_REQUEST: 'PAYMENT_GATEWAY_UPDATE_REQUEST',
  PAYMENT_GATEWAY_UPDATE_SUCCESS: 'PAYMENT_GATEWAY_UPDATE_SUCCESS',
  PAYMENT_GATEWAY_UPDATE_FAILURE: 'PAYMENT_GATEWAY_UPDATE_FAILURE',

  PAYMENT_GATEWAY_DELETE_REQUEST: 'PAYMENT_GATEWAY_DELETE_REQUEST',
  PAYMENT_GATEWAY_DELETE_SUCCESS: 'PAYMENT_GATEWAY_DELETE_SUCCESS',
  PAYMENT_GATEWAY_DELETE_FAILURE: 'PAYMENT_GATEWAY_DELETE_FAILURE',

  PAYMENT_METHOD_GATEWAY_FETCH_REQUEST: 'PAYMENT_METHOD_GATEWAY_FETCH_REQUEST',
  PAYMENT_METHOD_GATEWAY_FETCH_SUCCESS: 'PAYMENT_METHOD_GATEWAY_FETCH_SUCCESS',
  PAYMENT_METHOD_GATEWAY_FETCH_FAILURE: 'PAYMENT_METHOD_GATEWAY_FETCH_FAILURE',

  PAYMENT_METHOD_GATEWAY_CREATE_REQUEST: 'PAYMENT_METHOD_GATEWAY_CREATE_REQUEST',
  PAYMENT_METHOD_GATEWAY_CREATE_SUCCESS: 'PAYMENT_METHOD_GATEWAY_CREATE_SUCCESS',
  PAYMENT_METHOD_GATEWAY_CREATE_FAILURE: 'PAYMENT_METHOD_GATEWAY_CREATE_FAILURE',

  PAYMENT_METHOD_GATEWAY_UPDATE_REQUEST: 'PAYMENT_METHOD_GATEWAY_UPDATE_REQUEST',
  PAYMENT_METHOD_GATEWAY_UPDATE_SUCCESS: 'PAYMENT_METHOD_GATEWAY_UPDATE_SUCCESS',
  PAYMENT_METHOD_GATEWAY_UPDATE_FAILURE: 'PAYMENT_METHOD_GATEWAY_UPDATE_FAILURE',

  PAYMENT_METHOD_GATEWAY_DELETE_REQUEST: 'PAYMENT_METHOD_GATEWAY_DELETE_REQUEST',
  PAYMENT_METHOD_GATEWAY_DELETE_SUCCESS: 'PAYMENT_METHOD_GATEWAY_DELETE_SUCCESS',
  PAYMENT_METHOD_GATEWAY_DELETE_FAILURE: 'PAYMENT_METHOD_GATEWAY_DELETE_FAILURE',

  PAYMENT_METHODS_FETCH_REQUEST: 'PAYMENT_METHODS_FETCH_REQUEST',
  PAYMENT_METHODS_FETCH_SUCCESS: 'PAYMENT_METHODS_FETCH_SUCCESS',
  PAYMENT_METHODS_FETCH_FAILURE: 'PAYMENT_METHODS_FETCH_FAILURE',

  PAYMENT_METHOD_CREATE_REQUEST: 'PAYMENT_METHOD_CREATE_REQUEST',
  PAYMENT_METHOD_CREATE_SUCCESS: 'PAYMENT_METHOD_CREATE_SUCCESS',
  PAYMENT_METHOD_CREATE_FAILURE: 'PAYMENT_METHOD_CREATE_FAILURE',

  PAYMENT_METHOD_UPDATE_REQUEST: 'PAYMENT_METHOD_UPDATE_REQUEST',
  PAYMENT_METHOD_UPDATE_SUCCESS: 'PAYMENT_METHOD_UPDATE_SUCCESS',
  PAYMENT_METHOD_UPDATE_FAILURE: 'PAYMENT_METHOD_UPDATE_FAILURE',

  PAYMENT_METHOD_DELETE_REQUEST: 'PAYMENT_METHOD_DELETE_REQUEST',
  PAYMENT_METHOD_DELETE_SUCCESS: 'PAYMENT_METHOD_DELETE_SUCCESS',
  PAYMENT_METHOD_DELETE_FAILURE: 'PAYMENT_METHOD_DELETE_FAILURE',

  CHARGE_STATUS_FETCH_REQUEST: 'CHARGE_STATUS_FETCH_REQUEST',
  CHARGE_STATUS_FETCH_SUCCESS: 'CHARGE_STATUS_FETCH_SUCCESS',
  CHARGE_STATUS_FETCH_FAILURE: 'CHARGE_STATUS_FETCH_FAILURE',

  CHARGE_STATUS_CREATE_REQUEST: 'CHARGE_STATUS_CREATE_REQUEST',
  CHARGE_STATUS_CREATE_SUCCESS: 'CHARGE_STATUS_CREATE_SUCCESS',
  CHARGE_STATUS_CREATE_FAILURE: 'CHARGE_STATUS_CREATE_FAILURE',

  CHARGE_STATUS_UPDATE_REQUEST: 'CHARGE_STATUS_UPDATE_REQUEST',
  CHARGE_STATUS_UPDATE_SUCCESS: 'CHARGE_STATUS_UPDATE_SUCCESS',
  CHARGE_STATUS_UPDATE_FAILURE: 'CHARGE_STATUS_UPDATE_FAILURE',

  CHARGE_STATUS_DELETE_REQUEST: 'CHARGE_STATUS_DELETE_REQUEST',
  CHARGE_STATUS_DELETE_SUCCESS: 'CHARGE_STATUS_DELETE_SUCCESS',
  CHARGE_STATUS_DELETE_FAILURE: 'CHARGE_STATUS_DELETE_FAILURE',

  CHARGE_STATUS_GATEWAY_FETCH_REQUEST: 'CHARGE_STATUS_GATEWAY_FETCH_REQUEST',
  CHARGE_STATUS_GATEWAY_FETCH_SUCCESS: 'CHARGE_STATUS_GATEWAY_FETCH_SUCCESS',
  CHARGE_STATUS_GATEWAY_FETCH_FAILURE: 'CHARGE_STATUS_GATEWAY_FETCH_FAILURE',

  CHARGE_STATUS_GATEWAY_CREATE_REQUEST: 'CHARGE_STATUS_GATEWAY_CREATE_REQUEST',
  CHARGE_STATUS_GATEWAY_CREATE_SUCCESS: 'CHARGE_STATUS_GATEWAY_CREATE_SUCCESS',
  CHARGE_STATUS_GATEWAY_CREATE_FAILURE: 'CHARGE_STATUS_GATEWAY_CREATE_FAILURE',

  CHARGE_STATUS_GATEWAY_UPDATE_REQUEST: 'CHARGE_STATUS_GATEWAY_UPDATE_REQUEST',
  CHARGE_STATUS_GATEWAY_UPDATE_SUCCESS: 'CHARGE_STATUS_GATEWAY_UPDATE_SUCCESS',
  CHARGE_STATUS_GATEWAY_UPDATE_FAILURE: 'CHARGE_STATUS_GATEWAY_UPDATE_FAILURE',

  CHARGE_STATUS_GATEWAY_DELETE_REQUEST: 'CHARGE_STATUS_GATEWAY_DELETE_REQUEST',
  CHARGE_STATUS_GATEWAY_DELETE_SUCCESS: 'CHARGE_STATUS_GATEWAY_DELETE_SUCCESS',
  CHARGE_STATUS_GATEWAY_DELETE_FAILURE: 'CHARGE_STATUS_GATEWAY_DELETE_FAILURE',
};
